/**
 * Small validation-status icon used in the record list cell and inline with
 * the record heading in detail pane (TASK-159 / AV-01).
 *
 * Renders a compact symbol + tooltip per status:
 *  - VALID              → ✓ (green)
 *  - HAS_WARNINGS_ONLY  → ⚠ (amber)
 *  - HAS_ERRORS         → ✗ (red)
 *  - NOT_VALIDATED      → – (grey)
 *
 * The badge is intentionally minimal: text glyph + colour. Stripes provides
 * an Icon component but it doesn't ship the four exact symbols we need with
 * consistent semantic colouring, so we use raw text and inline styles. Visual
 * regression risk is low (the four glyphs are stable across browsers).
 */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip } from '@folio/stripes/components';
var STATUS_VISUALS = {
    VALID: {
        symbol: '✓',
        color: '#1b8a4e',
        labelKey: 'ui-czna-authorities.validation.status.valid',
    },
    HAS_WARNINGS_ONLY: {
        symbol: '⚠',
        color: '#b8860b',
        labelKey: 'ui-czna-authorities.validation.status.hasWarningsOnly',
    },
    HAS_ERRORS: {
        symbol: '✗',
        color: '#c0392b',
        labelKey: 'ui-czna-authorities.validation.status.hasErrors',
    },
    NOT_VALIDATED: {
        symbol: '–',
        color: '#888',
        labelKey: 'ui-czna-authorities.validation.status.notValidated',
    },
};
export var ValidationStatusBadge = function (_a) {
    var status = _a.status, title = _a.title;
    var intl = useIntl();
    var visual = STATUS_VISUALS[status];
    var tooltipText = title !== null && title !== void 0 ? title : intl.formatMessage({ id: visual.labelKey });
    var id = "validation-status-".concat(status);
    return (React.createElement(Tooltip, { text: tooltipText, id: id }, function (_a) {
        var ref = _a.ref, ariaIds = _a.ariaIds;
        return (React.createElement("span", { ref: ref, "aria-labelledby": ariaIds.text, "data-test-validation-status": status, style: {
                display: 'inline-block',
                color: visual.color,
                fontWeight: 700,
                fontSize: '1.15em',
                lineHeight: 1,
                minWidth: '1.2em',
                textAlign: 'center',
            } },
            visual.symbol,
            React.createElement("span", { style: { display: 'none' } },
                React.createElement(FormattedMessage, { id: visual.labelKey }))));
    }));
};
export default ValidationStatusBadge;
